import React from 'react'
import { connect } from 'react-redux'
import Wind from '../../../../../lib/api/wind'
import './index.scss'
import DisplayHourly from '../../../common/hunt-wind/display-hourly'
import { blockFeatures, unBlockFeatures } from '../../../../../action/features-blocked-actions'
import SubPopup from '../../../common/hunt-wind/sub-popup'

class HuntWind extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      forcast: null,
      showProModal: false
    }
    this.lat = ''
    this.lng = ''
    this.latRef = React.createRef()
    this.lngRef = React.createRef()
    this.clickListener = null
    this.moveListener = null
    this.proWillShow = false
    this.arrowDiv = null
    this.handleMove = this.handleMove.bind(this)
  }

  componentDidMount() {
    const { mapReference, token, blockFeatures, unBlockFeatures } = this.props,
      { fetchHourly } = Wind,
      map = document.getElementById('map')
    mapReference.setOptions({ draggableCursor: 'crosshair' })
    blockFeatures()

    this.arrowDiv = document.createElement('div')
    this.arrowDiv.classList.add('hunt-wind-preview-arrow')
    document.body.appendChild(this.arrowDiv)
    this.moveListener = map.addEventListener('mousemove', this.handleMove)

    this.clickListener = google.maps.event.addListenerOnce(mapReference, 'click', (e) => {
      const lat = e.latLng.lat(),
        lng = e.latLng.lng()
      window.removeEventListener('mousemove', this.handleMove)
      this.moveListener = null
      this.arrowDiv.remove()
      mapReference.setCenter(e.latLng)
      if (mapReference.getZoom() < 17) {
        mapReference.setZoom(17)
      }
      this.lat = Math.round(lat * 1000000) / 1000000
      this.lng = Math.round(lng * 1000000) / 1000000
      this.latRef.current.innerText = lat
      this.lngRef.current.innerText = lng
      this.clickListener = null
      unBlockFeatures()
      mapReference.setOptions({ draggableCursor: 'grab' })

      fetchHourly({ lat, lng, token })
        .then(res => {
          this.setState({ forcast: res })
        })
        .catch(err => {
          console.error('Wind hourly fetch failed Hunt-Wind: ', err)
        })
    })
  }

  componentWillUnmount() {
    const { mapReference, unBlockFeatures } = this.props
    unBlockFeatures()
    if (this.clickListener !== null) {
      this.clickListener.remove()
      mapReference.setOptions({ draggableCursor: 'grab' })
    }
    if (this.moveListener !== null) {
      const map = document.getElementById('map')
      map.removeEventListener('mousemove', this.handleMove)
      this.arrowDiv.remove()
    }
  }

  handleMove(e) {
    const { clientX, clientY } = e,
      x = `${clientX - 10}px`,
      y = `${clientY - 10}px`,
      transform = `translate(${x}, ${y})`
    this.arrowDiv.style.transform = transform
  }

  toggleProModal() {
    this.proWillShow = !this.proWillShow
    this.setState({ showProModal: !this.state.showProModal })
  }

  render() {
    return (
      <div className='hunt-wind-container'>
        <div className='hunt-wind-header'>HuntWind&#8482;</div>
        <div className='hunt-wind-title-icon'></div>
        <div className='hunt-wind-prompt'>Select the location you would like to see wind direction.</div>
        <div className='hunt-wind-lat-lng'>
          <div className='hunt-wind-coord-entry'>
            <p>Latitude:</p>
            <div className='hunt-wind-coord-box' ref={this.latRef}>
              {this.lat ? this.lat : 'Click map to set...'}
            </div>
          </div>
          <div className='hunt-wind-coord-entry'>
            <p>Longitude:</p>
            <div className='hunt-wind-coord-box' ref={this.lngRef}>
              {this.lng ? this.lng : 'Click map to set...'}
            </div>
          </div>
        </div>
        <DisplayHourly
          user={this.props.user}
          modalVisible={this.proWillShow}
          toggleProModal={this.toggleProModal.bind(this)}
          forcast={this.state.forcast}
          position={{ lat: this.lat, lng: this.lng }} />
        {
          this.state.showProModal ? (
            <SubPopup hidePopup={this.toggleProModal.bind(this)} />
          ) : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  token: state.auth.token,
  user: state.user,
  mapReference: state.mapReference()
})

const mapDispatchToProps = dispatch => ({
  blockFeatures: () => dispatch(blockFeatures()),
  unBlockFeatures: () => dispatch(unBlockFeatures())
})

export default connect(mapStateToProps, mapDispatchToProps)(HuntWind)